<div class="ticket light">
  <div class="ticket-body">
    <p class="coupon-name">Cupón</p>
    <p class="coupon-price">100%</p>
    <p class="coupon-free">Gratis</p>
  </div>
  <div class="footer">
    <div class="disclaimer" nz-typography nzEllipsis>{{ name }}</div>
  </div>
</div>
